import React, {useState, useEffect} from 'react'
import HeadingArea from '../general/HeadingArea'
import ResponseMsg2 from '../general/ResponseMsg2';
import { FaCheck } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';


const FeeParticular = ({setLoading}) => {
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [formData, setFormData] = useState({
      fee_category: '',
      fee_type: '',
      description: '',
    });
  const [particular, setParticular] = useState([]);
const [showDelete, setShowDelete] = useState(false);
const [selectedPart, setSelectedPart] = useState('');
 const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

    const fetchParticular = async (e) => {
                  setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-fee-particular');
      
                      if (response.ok) {
                          const data = await response.json();
                          setParticular(data);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch coupon');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
              };
  
  
                      useEffect(() => {
                        fetchParticular();
                      }, [])
  

      const handleChange = (e) => {
    const { name, value } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
  };


const handleSubmit = async (e) => {
    e.preventDefault();

    if (isEditing) {
      try {
        const response = await fetch(`https://api.kcian.in/edit-fee-particular/${editId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (response.ok) {
          fetchParticular();
          setResponse2({ message: data.message || 'Fee Particular Updated Successfully.', status: 'success' });
          setIsEditing(false);
          setEditId(null);
          setFormData({ fee_category: '', fee_type: '', description: '' });
        } else {
        setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const response = await fetch('https://api.kcian.in/add-particular', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (response.ok) {
          fetchParticular();
          setResponse2({ message: data.message || 'Fee Particular Added Successfully.', status: 'success' });
          setFormData({ fee_category: '', fee_type: '', description: '' });
        } else {
          setResponse2({ message: data.message || 'Something went wrong. Please try again.', status: 'error' });
        }
      } catch (error) {
        console.log(error);
        // setResponse2({ message: 'Something went wrong. Please try again.', status: 'error' });
      }
    }

    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  };


 const handleEdit = (part) => {
    setFormData({
      fee_category: part.fee_category,
      fee_type: part.fee_type,
      description: part.description || '',
    });
    setIsEditing(true);
    setEditId(part.id);
  };

  const cancelEdit = () => {
    setIsEditing(false);
    setEditId(null);
    setFormData({ fee_category: '', fee_type: '', description: '' });
  };


    const handleShowDelete = (myPart) => {
    setSelectedPart(myPart);
    setShowDelete(true);
  }


              const handleDelete = async (partId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-fee-particular/${partId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setParticular((prevData) => prevData.filter((product) => product.id !== partId));
        setShowDelete(false);
        setResponse2({ message: 'Fee Particular Deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };


  return (
    <>
      <section className='py-4'>
      <div className='px-4'>

<HeadingArea message1='General Settings' message2='Change Fees Particulars' />


                  <p className='text-center profile-heading'>Fees Particulars</p>

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}


        <div className='row'>
          <div className='col-lg-4 col-12 my-2'>
            <div className='profile-card'>
              <p className='fw-bold fm-mont fs-5 text-center mb-4'>{isEditing ? 'Edit Here' : 'Add New'}</p>


              <form encType='multipart/form-data' onSubmit={handleSubmit}>
                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Fees Category*</label>
                  <input
                    type='text'
                    name='fee_category'
                    className='profile-input'
                    value={formData.fee_category}
                    onChange={handleChange}
                    placeholder='New Admission, Transport, Re Admission, Form'
                    required
                  />
</div>                </div>

                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Type of Fees*</label>
                  <input
                    type='text'
                    name='fee_type'
                    className='profile-input'
                    value={formData.fee_type}
                    onChange={handleChange}
                    placeholder='Reg Fee, Application Fee, Admission Fee, Monthly Fee'
                    required
                  />
</div>                </div>


                <div className='mb-4'>
                    <div className='profile-input-area'>
                  <label className='profile-badge'>Description</label>
                  <textarea
                    type='text'
                    name='description'
                    className='profile-input'
                    value={formData.description}
                    onChange={handleChange}
                  ></textarea>
</div>                </div>



<div className='text-center'>
                <button type='submit' className='profile-btn'>
                  <FaCheck /> {isEditing ? 'Update' : 'Save'}
                </button>
                 {isEditing && (
                      <button
                        type='button'
                        onClick={cancelEdit}
                        className='profile-btn2 ms-2'
                      >
                        Cancel
                      </button>
                    )}</div>

              </form>


</div>
</div>


<div className='col-lg-8 col-12 my-2'>
    <div className='profile-card'>
<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>S No</th>
    <th>Fee Category</th>
    <th>Fee Type</th>
    <th>Description</th>
    <th className='rounded-end-4'>Actions</th>
</thead>

{particular.map((myPart, index) => (
  <tr className='account-tr'>
    <td>{index+1}</td>
    <td>{myPart.fee_category}</td>
    <td>{myPart.fee_type}</td>
    <td>{myPart.description || '-'}</td>
    <td><MdOutlineEdit className='account-icon1' onClick={() => handleEdit(myPart)} /> &nbsp;&nbsp;<RiDeleteBin6Line className='account-icon2' onClick={() => handleShowDelete(myPart)} /></td>
  </tr>
))}


</table>
</div>
{/* table ends */}

</div>
</div>


</div>
{/* row ends */}


</div>
</section>


{showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove Fee Particular!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Fee Category</th>
    <th>Fee Type</th>
    <th className='rounded-end-4'>Description</th>
</thead>

<tr className='account-tr'>
<td>{selectedPart.fee_category}</td>
<td>{selectedPart.fee_type}</td>
<td>{selectedPart.description || '-'}</td>

</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Fee Particular will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedPart.id)}>Remove Item</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}
    </>
  )
}

export default FeeParticular
